import {
  AgColDefsI,
  AgGridI,
  paginationModel,
} from "../../shared/common-components/ag-grid/ag-grid.model";
import { CheckboxCellrenderComponent } from "../../shared/common-components/ag-grid/checkbox-cellrender/checkbox-cellrender.component";
import { CustomHeaderComponent } from "../../shared/common-components/ag-grid/custom-header/custom-header.component";
import { TextRendererComponent } from "../../shared/common-components/ag-grid/text-renderer/text-renderer.component";
import { ResetDeleteIconComponent } from "../../shared/common-components/ag-grid/reset-delete-icon/reset-delete-icon.component";
import { ActionColWidth, CategoryColWidth, NameColWidth, StatusColWidth } from "../../shared/enum/common-enum";

export class Masters {}

const ActiveColumn: AgColDefsI = {
  headerName: "Active",
  field: "active",
  minWidth: StatusColWidth.minWidth,
  headerComponent: CustomHeaderComponent,
  maxWidth: 100,
  sortable: false,
  editable: false,
  resizable: false,
  lockPinned: true,
  headerClass: "ag_header_center custom-column-group-cell",
  cellClass:
    "custom-column-group-cell d-flex align-items-center justify-content-center",
  cellRenderer: CheckboxCellrenderComponent,
  cellRendererParams: { disabled: true, isCursor: false },
};
const CategoryColumn: AgColDefsI = {
  headerName: "Category",
  field: "categoryName",
  headerComponent: CustomHeaderComponent,
  minWidth: CategoryColWidth.minWidth,
  sortable: true,
  editable: false,
  headerClass: "custom-column-group-cell",
  cellClass: "custom-column-group-cell",
  cellRendererParams: { isCursor: false },
  cellRenderer: TextRendererComponent,
};
const CountryColumn: AgColDefsI = {
  headerName: "Country",
  field: "countryName",
  headerComponent: CustomHeaderComponent,
  minWidth: NameColWidth.minWidth,
  sortable: true,
  editable: false,
  headerClass: "custom-column-group-cell",
  cellClass: "custom-column-group-cell",
  cellRendererParams: { isCursor: false },
  cellRenderer: TextRendererComponent,
};
const Action: AgColDefsI = {
  headerName: "",
  field: "",
  maxWidth: ActionColWidth.maxWidth,
  sortable: false,
  editable: false,
  headerComponentParams: { enablePlusIcon: true },
  cellRendererParams: {
    editIcon: true,
    isDeleteIcon: true,
  },
  cellRenderer: ResetDeleteIconComponent,
  lockPinned: true,
  pinned: "right",
  headerClass: "custom-column-group-cell",
  cellClass: "custom-column-group-cell",
  cellStyle: "cursor-pointer",
};

export const MastersColumnDef: AgColDefsI[] = [
  CategoryColumn,
  CountryColumn,
  ActiveColumn,
  Action,
];
export const AgGridDataModelMastersList: AgGridI = {
  colDefs: MastersColumnDef,
  rowSelection: "multiple",
  rowHeight: 40,
};

export class MastersCategoryModel {
  id: string;
  categoryName: string;
  countryId: number;
  active: boolean = true;
}

export class MastersRequestModelList extends paginationModel {
  fromDate: string;
  toDate: string;
}
